<template>
  <el-row class="container_self table_parent">
    <el-row class="add_btn"
      ><el-button type="primary" icon="el-icon-plus" size="mini" @click="showAddDialog"
        >新增升级包</el-button
      ></el-row
    >
    <h3>升级包列表</h3>
    <el-table :data="apkList" v-loading="loading">
      <el-table-column label="ID" prop="id" align="center" width="80"></el-table-column>
      <el-table-column
        label="渠道ID"
        prop="channelId"
        align="center"
        width="300"
      ></el-table-column>
      <el-table-column
        label="版本号"
        prop="versionCode"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        label="版本名称"
        prop="versionName"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        label="升级包Url"
        prop="fileUrl"
        align="center"
        width="300"
      ></el-table-column>
      <el-table-column label="是否启用" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.enabled">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="是否强制更新" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.forceUpdate">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column
        label="升级包描述"
        prop="description"
        align="center"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        align="center"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="updateApk(scope.row)"
            >更新</el-button
          >
          <el-button size="mini" type="danger" @click="deleteApk(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="string + '升级包'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form ref="form" :rules="rules" size="mini" :model="form" label-width="120px">
        <el-form-item label="渠道ID" prop="channelId">
          <el-select v-model="form.channelId" style="width: 100%">
            <el-option
              v-for="(item, index) in channelList"
              :label="item.channelId"
              :value="item.channelId"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.enabled">
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="升级包描述">
          <el-input v-model="form.description" />
        </el-form-item>
        <el-form-item label="上传升级包">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            ref="uploadApk"
            accept=".apk"
            :auto-upload="true"
            :headers="{ Authorization: token }"
            :show-file-list="true"
            :on-success="handleuploadSuccessApk"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="升级包链接">
          <el-input v-model="form.fileUrl" />
        </el-form-item>
        <el-form-item label="是否强制更新">
          <el-select v-model="form.forceUpdate">
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="versionCode">
          <el-input v-model="form.versionCode" type="number" />
        </el-form-item>
        <el-form-item label="版本名称" prop="versionName">
          <el-input v-model="form.versionName" />
        </el-form-item>
        <el-form-item label-width="0px" style="text-align: center">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="submit('form')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      apkList: [],
      apkForm: {
        channelId: "",
        enabled: "",
        currentPage: 1,
        pageSize: 20,
      },
      dialogFormVisible: false,
      form: {
        channelId: "",
        description: "",
        enabled: 1,
        fileUrl: "",
        forceUpdate: 1,
        versionCode: "",
        versionName: "",
      },
      channelList: [],
      string: "新增",
      loading: false,
      isEdit: false,
      fileList: [],
      rules: {
        channelId: [
          { required: true, message: "请输入渠道ID", trigger: "blur" },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "渠道ID不能包含中文字符",
            trigger: "blur",
          },
        ],
        versionCode: [
          { required: true, message: "请输入版本号", trigger: "blur" },
          {
            pattern: /^(\d+|\d*\\d{1,10})$/,
            message: "版本号只能是整数",
            trigger: "blur",
          },
        ],
        versionName: [{ required: true, message: "请输入版本名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    getApkList(params) {
      this.loading = true;
      axiosGet("/api/package/list", params).then((res) => {
        if (res.code == 0) {
          this.loading = false;
          this.apkList = res.data.records;
        } else {
          this.loading = false;
        }
      });
    },
    showAddDialog() {
      if (this.$refs.form) {
        this.$refs.form.resetFields(); // 重置表单验证
      }
      this.isEdit = false;
      this.dialogFormVisible = true;
      this.form = {
        channelId: "",
        description: "",
        enabled: 1,
        fileUrl: "",
        forceUpdate: 1,
        versionCode: "",
        versionName: "",
      };
      axiosGet("/api/channel/list", { currentPage: 1 }).then((res) => {
        if (res.code == 0) {
          this.channelList = res.data.records;
        }
      });
    },
    async submit(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });

      if (valid) {
        const url = this.isEdit ? "/api/package/update" : "/api/package/add";
        axiosPost(url, this.form, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "升级包" + this.string + "成功", type: "success" });
            this.dialogFormVisible = false;
            this.getApkList(this.apkForm);
          }
        });
      }
    },
    handleuploadSuccessApk(res, file) {
      if (res.code == 0) {
        this.form.fileUrl = res.data.url;
        this.$refs.uploadApk.clearFiles();
        this.$forceUpdate();
      }
    },
    updateApk(row) {
      if (this.$refs.form) {
        this.$refs.form.resetFields(); // 重置表单验证
      }
      this.string = "更新";
      this.isEdit = true;
      this.form = {
        channelId: row.channelId,
        description: row.description,
        enabled: row.enabled,
        fileUrl: row.fileUrl,
        forceUpdate: row.forceUpdate,
        versionCode: row.versionCode,
        versionName: row.versionName,
        id: row.id,
      };
      axiosGet("/api/channel/list", { currentPage: 1 }).then((res) => {
        if (res.code == 0) {
          this.channelList = res.data.records;
        }
      });
      this.dialogFormVisible = true;
    },
    deleteApk(id) {
      this.$confirm("此操作将永久删除id为 " + id + " 的升级包, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/package/delete", { id: id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "升级包删除成功", type: "success" });
              this.getApkList(this.apkForm);
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getApkList(this.apkForm);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/AppManager/ApkManager.vue